import { c as _c } from "react/compiler-runtime";
import { useLocalization } from '@/app/(app)/_providers/localization/LocalizationProvider';
import type { ModeValue } from './ModeTabs';
export function QuickPrompts(t0) {
  const $ = _c(12);
  const {
    mode,
    onSelect
  } = t0;
  const {
    messages
  } = useLocalization();
  let t1;
  let t2;
  if ($[0] !== messages.chat.welcomeQuickPrompts.compare || $[1] !== messages.chat.welcomeQuickPrompts.consultant || $[2] !== messages.chat.welcomeQuickPrompts.problemSolver || $[3] !== mode || $[4] !== onSelect) {
    const promptMap = {
      consultant: messages.chat.welcomeQuickPrompts.consultant,
      "problem-solver": messages.chat.welcomeQuickPrompts.problemSolver,
      compare: messages.chat.welcomeQuickPrompts.compare
    };
    const quickPrompts = promptMap[mode].map(_temp);
    t1 = "flex w-full max-w-140 flex-wrap items-center justify-center gap-2";
    let t3;
    if ($[7] !== onSelect) {
      t3 = prompt_0 => <button key={prompt_0.label} type="button" onClick={() => onSelect(prompt_0.desc)} className="border-border bg-background hover:bg-muted hover:border-muted-foreground inline-flex items-center rounded-full border px-3.5 py-1.5 text-left transition-colors"><span className="text-muted-foreground hover:text-foreground text-[12px] font-medium transition-colors">{prompt_0.label}</span></button>;
      $[7] = onSelect;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = quickPrompts.map(t3);
    $[0] = messages.chat.welcomeQuickPrompts.compare;
    $[1] = messages.chat.welcomeQuickPrompts.consultant;
    $[2] = messages.chat.welcomeQuickPrompts.problemSolver;
    $[3] = mode;
    $[4] = onSelect;
    $[5] = t1;
    $[6] = t2;
  } else {
    t1 = $[5];
    t2 = $[6];
  }
  let t3;
  if ($[9] !== t1 || $[10] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}
function _temp(prompt) {
  return {
    label: prompt,
    desc: prompt
  };
}